import { ProductViewConfigurator } from '~/types/configurator';
import configuratorChoices from '~/data/configuratorChoices/bagConfiguratorChoices';

let label;
let imageUrl;
let description;

export default {
    controls: [
        {
            key: 'color',
            keyLabel: 'color',
            label: 'Color',
            displayAsImages: true,
            choices: [
                {
                    label: (label = 'White Kraft'),
                    detailsModalLabel: label,
                    imageUrl: (imageUrl =
                        '/images/configurator-choices/color-white-tube.webp'),
                    detailsModalImageUrl: imageUrl,
                    value: 'white',
                    description: (description =
                        'A gently-textured, paper-based material that’s light, strong, and 100% curbside recyclable. Kraft paper tubes can stand up to rough handling during shipping and keep their contents intact.'),
                    detailsModalDescription: description,
                },
                {
                    label: (label = 'Brown Kraft'),
                    detailsModalLabel: label,
                    imageUrl: (imageUrl =
                        '/images/configurator-choices/color-brown-tube.webp'),
                    detailsModalImageUrl: imageUrl,
                    value: 'brown',
                    description: (description =
                        'All the properties and benefits of white kraft, presented in a pleasing shade of brown. Brown kraft paper tubes feature a white inner layer.'),
                    detailsModalDescription: description,
                },
                configuratorChoices.colors.customWithoutPattern,
            ],
            detailsModalLabel: 'Color options:',
        },
    ],
} as ProductViewConfigurator;
